module.exports = __webpack_public_path__ + "static/media/AO.1d8a5da7.png";